export default __webpack_public_path__ + "static/media/expert_2.421b4286.png";